<template>
  <div>
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      class="px-14 font-weight-bold text-uppercase text-body-1"
      :color="!secondary ? 'primary' : 'white'"
      :outlined="secondary"
      height="48px"
      :width="width"
      depressed
      rounded
    >
      <span class="font-secondary">
        <slot />
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "auto",
    },
  },
};
</script>
